var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.662 0.211999V1.724C2.574 1.832 1.296 3.074 1.296 4.946C1.296 6.674 2.358 7.682 4.662 8.15V13.352C2.7 13.208 1.8 12.236 1.836 10.31H0.792C0.738 12.686 2.214 14.18 4.662 14.234V16.286H5.436V14.234C6.408 14.162 6.966 14.036 7.47 13.73C8.532 13.118 9.108 12.074 9.108 10.778C9.108 8.852 7.992 7.79 5.436 7.304V2.624C6.984 2.732 7.776 3.542 7.812 5.072L8.838 5.09C8.892 3.092 7.596 1.814 5.436 1.724V0.211999H4.662ZM4.662 7.124C3.906 6.944 3.582 6.818 3.294 6.638C2.646 6.26 2.304 5.63 2.304 4.874C2.304 3.524 3.186 2.678 4.662 2.606V7.124ZM5.436 8.312C6.444 8.618 6.678 8.708 6.984 8.888C7.704 9.302 8.082 9.968 8.082 10.85C8.082 11.606 7.794 12.272 7.236 12.722C6.786 13.118 6.318 13.28 5.436 13.352V8.312Z",
    fill: "#3B4B59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/Dollar.a9e541f971ee4fa000035a28e3890a4c.svg";
export { ForwardRef as ReactComponent };